import { SVGProps } from "react";

export const AddressPinIcon = ({
  width = 17,
  height = 25,
  color = "#25292D",
  ...props
}: SVGProps<SVGSVGElement> & { pulse?: boolean; pulseColor?: string }) => {
  return (
    <div className="relative inline-block" style={{ width: `${width}px`, height: `${height}px` }}>
      <div
        className="absolute rounded-full animate-glow-outer-icon w-4 h-4 opacity-10 top-0.5 left-0.5 transform translate-x-1/2"
        style={{ backgroundColor: color }}
      />
      <div
        className="absolute rounded-full animate-glow-inner-icon w-4 h-4 opacity-10 top-0.5 left-0.5 transform translate-x-1/2"
        style={{ backgroundColor: color }}
      />

      <svg
        width={width}
        height={height}
        viewBox="0 0 17 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: "absolute", top: 0, left: 0 }}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.34188 12.5099C10.6419 12.5099 12.5119 10.6399 12.5119 8.33992C12.5119 6.03992 10.6419 4.16992 8.34188 4.16992C6.04188 4.16992 4.17188 6.03992 4.17188 8.33992C4.17188 10.6399 6.04188 12.5099 8.34188 12.5099Z"
          fill="white"
        />
        <path
          d="M8.35 0C3.74 0 0 3.73 0 8.34C0 12.61 3.21 16.13 7.35 16.63V24C7.35 24.55 7.79 25 8.35 25C8.91 25 9.35 24.55 9.35 24V16.63C13.48 16.13 16.69 12.61 16.69 8.34C16.69 3.73 12.95 0 8.35 0ZM8.35 12.51C6.04 12.51 4.17 10.65 4.17 8.34C4.17 6.03 6.04 4.17 8.35 4.17C10.66 4.17 12.52 6.04 12.52 8.34C12.52 10.64 10.65 12.51 8.35 12.51Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
